import { News } from '@/modules/News';
import TbsPublicRepository from './client/TbsJsonAxiosPublicServerClient';
import WpRepository from './client/WpAxiosClient';

const resource = '';

export const useNewsRepository = () => {
  /**
   * **TBS公開サーバーから** お知らせ情報JSONを取得する
   */
  const getFromTBS = async () => {
    const { data } = await TbsPublicRepository.get<{ news: News[] }>(`${resource}/tch-info-app.json`).catch((e) => {
      throw e;
    });
    return data;
  };

  /**
   * **WordPressから** お知らせ情報JSONを取得する
   */
  const getFromWP = async () => {
    const { data } = await WpRepository.get<{ news: News[] }>(`/news`).catch((e) => {
      throw e;
    });
    return data;
  };

  return {
    getFromTBS,
    getFromWP,
  };
};

export type NewsRepository = ReturnType<typeof useNewsRepository>;
